import { render } from "./search-relatedlinks.vue?vue&type=template&id=26cc6125"
import script from "./search-relatedlinks.js?vue&type=script&lang=js"
export * from "./search-relatedlinks.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__